<div class="sidnav-container">
  
  <div class="sidebar-icon" (click)="startNewChat()">
    <mat-icon class="material-symbols-outlined" style="font-variation-settings: 'FILL' 0, 'wght' 100, 'GRAD' 0, 'opsz' 24;">
      edit_square
    </mat-icon>
  </div>

  <div class="sidnav">
    <div class="logo">
      <img width="51px"
      src="../assets/ollie-sparkle.svg" /> 
      <img class="beta" src="../assets/icon-beta.svg" alt="beta">
      <h1 class="ollie-title">Ollie</h1>
    </div>

    <button mat-button color="primary" class="new-chat" (click)="startNewChat()">+ NEW CHAT</button>
  </div>
</div>